<template>
  <div class="w-50 setting-cost-categories">

    <div class="table-responsive">
      <table class="table">
        <colgroup>
          <col width="50">
          <col>
          <col width="100">
          <col width="100">
        </colgroup>
        <tbody>
          <tr v-for="(record, index) in allRecords" :key="index">
            <td>{{ index + 1 }}.</td>
            <td>
              <strong>{{ record.name }}</strong>
            </td>
            <td align="right">
              <a href="javascript:;" class="icon-pencil" v-tooltip="'Edit'" @click="editItem( index )"></a>
            </td>
            <td align="left">
              <a href="javascript:;" class="icon-trash" v-tooltip="'Delete'" @click="confDelete( index )"></a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5">
              <button type="button" class="btn btn-outline-black" @click="editItem(-1)">
                + Add New</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <modal-edit v-model="showModalEdit" :moduleName="moduleName" :item="activeItem" @item-saved="onItemSaved"></modal-edit>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Service from '@/services/costcategory'
import ModalEdit from "./ModalEdit";

export default {
  components: {
    ModalEdit,
  },
  data () {
    return {
      moduleName: 'CATEGORY',
      showModalEdit: false,
      activeIndex: -1,
    }
  },
  computed: {
    ...mapGetters(['COST_CATEGORIES']),
    allRecords () {
      let self = this;
      return self.COST_CATEGORIES;
    },
    activeItem () {
      let self = this;
      return self.allRecords[self.activeIndex] ? self.allRecords[self.activeIndex] : null;
    },
  },
  mounted () {
  },
  methods: {
    editItem ( index ) {
      let self = this;
      self.activeIndex = index;
      self.showModalEdit = true;
    },
    onItemSaved ( item ) {
      let self = this, list = self.allRecords;
      if(self.activeIndex != -1)
        list.splice( self.activeIndex, 1, item );
      else
        list.push( item );
      self.$store.dispatch( 'SET_COST_CATEGORIES', list );
    },
    confDelete ( index ) {
      let self = this, item = self.allRecords[index];

      self.$dialog
        .confirm('Are you sure you want to delete record "<strong>' + item.name + '</strong>"?', {
          html: true,
          loader: true,
          okText: "Yes, I'm sure",
          cancelText: "Cancel",
        })
        .then(dialog => {
          Service.delete(item.id, resp => {
            dialog.close();

            if ( resp.status == 'SUCCESS' ) {
              self.$notify({
                type: 'success',
                text: 'Record <strong>' + item.name + '</strong> has been deleted'
              });

              let list = self.allRecords;
              list.splice( index, 1 );
              self.$store.dispatch( 'SET_COST_CATEGORIES', list );
            }
            else {
              self.$notify({
                type: 'error',
                text: resp.error
              });
            }
          });
        })
        .catch(() => {})
      ;
    },
  }
}
</script>
